export function renderHabitCard(habit, log, photoBlobUrl = null) {
  const isCompleted = log?.is_completed || false;
  const value = log?.value || 0;

  let progress = 0;
  if (habit.type === 'binary') {
    progress = isCompleted ? 100 : 0;
  } else {
    const goal = habit.goal || 1;
    if (habit.direction === 'decrease') {
      // If value is less than or equal to goal, it's 100% (good)
      // If value is more than goal, progress decreases
      progress = value <= goal ? 100 : Math.max(0, (goal / value) * 100);
    } else {
      progress = Math.min((value / goal) * 100, 100);
    }
  }

  return `
      <div 
        class="habit-item group p-5 bg-gray-50 rounded-[1.5rem] flex justify-between items-center hover:bg-white hover:shadow-xl hover:shadow-gray-100 transition-all border border-transparent hover:border-gray-100 cursor-pointer relative overflow-hidden"
        data-habit-id="${habit.id}"
      >
        <div class="flex-1">
          <div class="flex items-center space-x-2">
            <h4 class="font-bold text-df-sapphire text-lg">${habit.title}</h4>
            ${habit.isDirty ? '<span class="w-2 h-2 rounded-full bg-orange-400 animate-pulse" title="Sync pending..."></span>' : ''}
          </div>
          <div class="flex items-center space-x-2 mt-1">
            <p class="text-[11px] text-df-bluegrey uppercase font-black tracking-widest opacity-70">
              ${habit.type === 'binary' ? 'Binary' : `${value} / ${habit.goal} ${habit.unit}`}
              ${habit.type === 'numeric' && habit.direction === 'decrease' ? ' <span class="text-[10px] lowercase opacity-50">(or less)</span>' : ''}
            </p>
          </div>
          <div class="w-full h-1.5 bg-gray-200 rounded-full mt-4 overflow-hidden">
            <div class="h-full ${habit.direction === 'decrease' && value > habit.goal ? 'bg-orange-400' : 'bg-df-aqua'} transition-all duration-1000 ease-out" style="width: ${progress}%"></div>
          </div>
          
          ${photoBlobUrl ? `
            <div class="mt-4 relative w-20 h-20 rounded-2xl overflow-hidden border-2 border-white shadow-md animate-in zoom-in-50 duration-500">
                <img src="${photoBlobUrl}" class="w-full h-full object-cover" />
                <button class="btn-delete-photo absolute top-1 right-1 bg-black/50 text-white rounded-full p-1 opacity-0 hover:opacity-100 transition-opacity" data-log-id="${log.id}">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
          ` : log ? `
            <button class="btn-add-photo mt-4 px-3 py-1.5 bg-df-bluegrey/10 text-df-bluegrey rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-df-bluegrey hover:text-white transition-all flex items-center gap-1.5" data-log-id="${log.id}">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Add Meal Photo
            </button>
          ` : ''}
        </div>
        <div class="flex items-center space-x-3 ml-4">
          <button class="btn-edit-habit p-2 text-df-bluegrey opacity-0 group-hover:opacity-40 hover:!opacity-100 hover:text-df-sapphire transition-all" data-habit-id="${habit.id}" onclick="event.stopPropagation()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </button>
          <div class="w-14 h-14 rounded-[1.25rem] flex items-center justify-center transition-all duration-500 
            ${isCompleted ? 'bg-df-aqua text-white shadow-xl shadow-df-aqua/30 scale-105' : 'bg-white border border-gray-100 text-gray-200 hover:border-df-aqua/50'}">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      </div>
    `;
}
